<template>
  <div id="typography">
    <div class="row">
      <div class="col-md-6">
        <h5>
          <code>Circular Std</code>
        </h5>
        <h3>A B C D E F G H I J K L M N O P Q R S T U V W X Y Z</h3>
        <h3 style="text-transform: lowercase;">A B C D E F G H I J K L M N O P Q R S T U V W X Y Z</h3>
        <h3>0 1 2 3 4 5 6 7 8 9</h3>
        <h1 class="display-1">Display 60px</h1>
        <h1 class="display-2">Display 48</h1>
        <h1 class="display-3">Display 36</h1>
        <h1 class="display-4">Display 28</h1>
        <h1>h1. heading 24px</h1>
        <h2>h2. heading 22px</h2>
        <h3>h3. heading 20px</h3>
        <h4>h4. heading 18px</h4>
        <h5>h5. heading 16px</h5>
      </div>
      <div class="col-md-6">
        <h5>
          <code>Proxima Nova</code>
        </h5>
        <h3 style="font-family:Proxima Nova; font-weight:400">A B C D E F G H I J K L M N O P Q R S T U V W X Y Z</h3>
        <h3 style="font-family:Proxima Nova; font-weight:400; text-transform: lowercase;">A B C D E F G H I J K L M N O P Q R S T U V W X Y Z</h3>
        <h3 style="font-family:Proxima Nova; font-weight:400">0 1 2 3 4 5 6 7 8 9</h3>
        <p>
          <span style="font-family: 'Proxima Nova Bold'; font-weight: 400;">Proxima Nova Bold</span>
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span style="font-family: 'Proxima Nova Semibold'; font-weight: 400;">Proxima Nova Semibold</span><br>
          <span style="font-family: 'Proxima Nova'; font-weight: 400;">Proxima Nova Regular</span>
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span style="font-family: 'Proxima Nova Light'; font-weight: 400;">Proxima Nova Light</span>
        </p>
        <p class="lead">This is an example of leading paragragh.</p>
        <p class="text-muted">This is an example of muted text.</p>
        <p class="text-primary">This is an example of primary text.</p>
        <p class="text-success">This is an example of success text.</p>
        <!-- <p class="text-info">This is an example of info text.</p> -->
        <!-- <p class="text-warning">This is an example of warning text.</p> -->
        <p class="text-danger">This is an example of danger text.</p>
        <p class="text-sm">This is an example of small text.</p>
        <p>Use the mark tag to
          <mark>highlight</mark>
          text.
        </p>
        <p>Use the b tag to
          <b>bold</b>
          text, or use strong tag to
          <strong>emphasize</strong>
          text.
        </p>
        <p>
          <a href="#">Link default</a> &nbsp;
          <a class="link-alt" href="#">Link alt colour</a> &nbsp;
          <a class="text-underline" href="#">Underline link</a> &nbsp;
          <a class="disabled" href="#">Disabled link</a> &nbsp;
        </p>
        <dl>
          <dt>Description lists</dt>
          <dd>A description list is perfect for defining terms.</dd>
    
          <dt>Euismod</dt>
          <dd>
            Vestibulum id ligula porta felis euismod semper eget lacinia odio sem nec elit.
          </dd>
    
          <dt>Malesuada porta</dt>
          <dd>Etiam porta sem malesuada magna mollis euismod.</dd>
    
          <dt>Truncated term is truncated</dt>
          <dd>Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.</dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
let title = 'Typography'
let tagline = 'Text is the primary way that users digest content and accomplish work, so it’s important to use good typographic principles to establish a clear visual hierarchy and to maximize legibility'

export default {
  name: 'typography',
  beforeCreate: function () {
    this.$emit('update-title', title) 
    this.$emit('update-tagline', tagline) 
  },
}
</script>
